import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Contexts
import { AuthProvider } from './contexts/AuthContext';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import IntakeChoice from './pages/IntakeChoice';
import ChatIntake from './pages/ChatIntake';
import ConfirmSummary from './pages/ConfirmSummary';
import LiteFunnel from './pages/LiteFunnel';
import MagicLinkVerify from './pages/MagicLinkVerify';
import LiteResults from './pages/LiteResults';
import ValuationApp from './pages/ValuationApp';

// Components
import ProtectedRoute from './components/ProtectedRoute';

// Services
import { checkHealth } from './services/api';

function App() {
  const [apiError, setApiError] = useState(null);
  const [apiLoading, setApiLoading] = useState(true);

  // Check API health on app load
  useEffect(() => {
    const checkAPI = async () => {
      try {
        await checkHealth();
        setApiError(null);
      } catch (error) {
        setApiError(
          'Backend server is not running. Please start it with: cd backend && npm start'
        );
        console.error('API health check failed:', error);
      } finally {
        setApiLoading(false);
      }
    };

    checkAPI();
  }, []);

  // Show API error if backend is down
  if (apiError && !apiLoading) {
    return (
      <div className="app">
        <div className="error-container">
          <h2>Connection Error</h2>
          <p>{apiError}</p>
          <code>cd backend && npm install && npm start</code>
          <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
            The frontend is running, but it needs the backend server to function.
          </p>
        </div>
      </div>
    );
  }

  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/* /valuation: side-by-side chat-vs-form choice (Task 4 of
                conversational-intake). IntakeChoice fails closed to
                form-only whenever the backend reports chat as
                disabled/unavailable. */}
            <Route path="/valuation" element={<IntakeChoice />} />
            <Route path="/valuation/chat" element={<ChatIntake />} />
            {/* /valuation/confirm: confirm-before-compute gate (Task 6) — ChatIntake
                navigates here with { intakeId } once the LLM interview reports
                readyToConfirm. Nothing is computed until the owner reviews/corrects
                every field here and submits. */}
            <Route path="/valuation/confirm" element={<ConfirmSummary />} />
            <Route path="/valuation/form" element={<LiteFunnel />} />
            <Route path="/auth/verify" element={<MagicLinkVerify />} />

            {/* Protected routes */}
            <Route
              path="/results/:id"
              element={
                <ProtectedRoute>
                  <LiteResults />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <ValuationApp />
                </ProtectedRoute>
              }
            />

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
